import withLanguage from "../../HOC/withLanguage";
import React, { useEffect, useState } from "react";
import {Link} from "react-router-dom";
import {handleDocumentDownload, handleDownload} from "../Shared/helperFunctions";
import FaqAccordion from "./ArsimiDualComponents/FaqAccordion";

function Punedhenes({ language, endpoint, truncateAt = 100 }) {
    const [stats, setStats] = useState({});

    useEffect(() => {
        fetch("/api/statistic_data/statistic_dual_system")
            .then((res) => res.json())
            .then((data) => {
                setStats(data.records);
            })
            .catch((err) => console.error("API fetch error:", err));
    }, []);

    console.log(stats);

    return (
        <div>
            <div className="p-6">
                <section className="max-w-6xl mx-auto px-6 pt-10">
                    <h1 className="text-[28px] font-extrabold text-red-600 mb-4">{language.mainTitle}</h1>
                    <p className=" max-w-[548px] font-extrabold mb-4">{language.subText}</p>
                    <div className="flex flex-col md:flex-row items-center gap-2">
                        <Link to="/KualifikimDual" className="bg-red-600 text-white font-bold p-2 rounded-xl hover:bg-red-700 transition-colors text-center">
                            {language.redirectButton}
                        </Link>
                        <Link
                            to="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=12552"
                            target="_blank"
                            className="bg-red-600 text-white font-bold p-2 rounded-xl hover:bg-red-700 transition-colors text-center"
                        >
                            {language.publishButton}
                        </Link>
                        <Link
                            to="/KualifikimDual?page=DualApplication"
                            className="bg-red-600 text-white font-bold p-2 rounded-xl hover:bg-red-700 transition-colors text-center"
                        >
                            {language.redirectButton2}
                        </Link>
                    </div>
                </section>
            </div>

            <section>
                <div className="p-6">
                    <section className="max-w-6xl mx-auto px-6">
                        <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">{language.Title1}</h1>
                        <div className="border-2 border-red-600 rounded-3xl p-6">
                            <p className=" max-w-[548px] font-extrabold">{language.subTitle1}</p>
                            <p>
                                <span>{language.subText1} </span>
                                <span
                                    onClick={() => handleDocumentDownload("/documents/Marreveshje bashkepunimi dual.pdf")}
                                    className="text-blue-500 font-bold cursor-pointer"
                                >
                                    {language.subText1Download}
                                </span>
                            </p>
                            <p className=" max-w-[548px] font-extrabold pt-4">{language.subTitle2}</p>
                            <p>
                                <span>{language.subText2} </span>
                            </p>
                            <p className="pt-2">{language.subText3}</p>
                        </div>
                    </section>
                </div>

                <div className="p-6">
                    <section className="max-w-6xl mx-auto px-6">
                        <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">{language.Title2}</h1>
                        <div className="border-2 border-red-600 rounded-3xl p-6">
                            <p>
                                <span className=" max-w-[548px] font-extrabold">{language.subTitle3} </span>
                                {language.subText4}
                            </p>
                            <p>
                                <span className=" max-w-[548px] font-extrabold">{language.subTitle4}  </span>
                                {language.subText5}
                            </p>
                            <p>
                                <span className=" max-w-[548px] font-extrabold">{language.subTitle5}  </span>
                                {language.subText6}
                            </p>
                            <p>
                                <span className=" max-w-[548px] font-extrabold">{language.subTitle6}</span>
                                {language.subText7}
                            </p>
                            <p>
                                <span className=" max-w-[548px] font-extrabold">{language.subTitle7}</span>
                                {language.subText8}
                            </p>
                        </div>
                    </section>
                </div>

                <div className="p-6">
                    <section className="max-w-6xl mx-auto px-6">
                        <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">
                            {language.Title3}
                        </h1>
                        <div className="border-2 border-red-600 rounded-3xl p-6">
                            <p className=" max-w-[548px]">{language.subText9}</p>
                            <p className=" max-w-[548px]">{language.subText10}</p>
                            <p className=" max-w-[548px]">
                                {language.subTitle8}
                                <span className="pl-5">{language.subText11}</span>
                            </p>
                            <p className=" max-w-[650px]">
                                {language.subTitle9}
                                <span className="pl-5">{language.subText12}</span>
                            </p>
                            <p className=" max-w-[680px]">
                                {language.subTitle10}
                                <span className="pl-5">{language.subText13}</span>
                            </p>
                            <p className=" max-w-[548px]">{language.subText14}</p>
                            <p className=" max-w-[600px]">{language.subText15}</p>
                            <p className=" max-w-[708px]">{language.subText16}</p>
                        </div>
                    </section>
                </div>

                <div className="p-6">
                    <section className="max-w-6xl mx-auto px-6">
                        <h1 className="text-xl font-extrabold text-red-600 mb-4 pl-[15px]">{language.Title4}</h1>
                        <div className="border-2 border-red-600 rounded-3xl p-6">
                            <p className="pb-6">
                                <a href="https://qbz.gov.al/share/vRUBQETTSzetSUtAvFYAFQ"
                                   target="_blank"
                                   className="text-blue-600 underline hover:text-blue-800"
                                >
                                    {language.subText17}
                                </a>
                            </p>

                            <p className="pb-6">
                                <a href="https://qbz.gov.al/share/kdc6oZetSDqUST7vz5tseA"
                                   target="_blank"
                                   className="text-blue-600 underline hover:text-blue-800"
                                >
                                    {language.subText18}
                                </a>
                            </p>

                            <p className="pb-6">
                                <a href="https://qbz.gov.al/share/fn-l5ZzCQPOycy1bSugm7g"
                                   target="_blank"
                                   className="text-blue-600 underline hover:text-blue-800"
                                >
                                    {language.subText19}
                                </a>
                            </p>

                            <p className="pb-6">
                                <a href="https://qbz.gov.al/share/9D25wUM_QrSIjVUzhCRGxw"
                                   target="_blank"
                                   className="text-blue-600 underline hover:text-blue-800"
                                >
                                    {language.subText20}
                                </a>
                            </p>
                        </div>
                    </section>
                </div>

                <FaqAccordion whereIsShown="employer" title={language.faqTitle} />

                <section className=" max-w-5xl mx-auto py-6">
                    <div>
                        <h2 className="text-red-600 font-extrabold text-[20px] mb-6">{language.StatsTitle}</h2>
                        <div className="grid grid-cols-2 md:grid-cols-3 mb-10">
                            <div className="flex flex-col items-center">
                                <div className="border-2 border-red-600 rounded-3xl p-6">
                                    <img src="/dual/Picture8.png" alt="Description"/>
                                    <p className="text-gray-800 font-bold text-center pt-1">
                                        {stats[0]?.student_employee_count} {language.stat1}
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <div className="border-2 border-red-600 rounded-3xl p-6">
                                    <img src="/dual/Picture9.png" alt="Description"/>
                                    <p className="text-gray-800 font-bold text-center pt-1">
                                        {stats[0]?.employer_count} {language.stat2}
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <div className="border-2 border-red-600 rounded-3xl p-3.5">
                                    <img src="/dual/Picture10.png" alt="Description"/>
                                    <p className="text-gray-800 font-bold text-center max-w-[220px] pt-1">
                                        {stats[0]?.high_school_count} {language.stat3}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-10">
                        <h2 className="text-red-600 font-extrabold text-[20px] mb-6">{language.UsefulPagesTitle}</h2>
                        <div className="grid grid-cols-2 md:grid-cols-3">
                            <div className="flex flex-col items-center">
                                <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                    <a
                                        href="https://www.puna.gov.al/home"
                                        target="_blank"
                                        className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black"
                                    >
                                        {language.page1}
                                    </a>
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                    <a
                                        href="https://www.tatime.gov.al/"
                                        target="_blank"
                                        className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black"
                                    >
                                        {language.page2}
                                    </a>
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <div className="bg-gray-200 border border-gray-130 rounded-2xl p-3.5">
                                    <a
                                        href="https://inspektoriatipunes.gov.al/"
                                        target="_blank"
                                        className="text-[17px] font-extrabold text-center text-black underline underline-offset-2 decoration-black"
                                    >
                                        {language.page3}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
}

export default withLanguage(Punedhenes, "Punedhenes");
